var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-4" },
    [
      _vm.onfilter
        ? _c("modal-filter", {
            attrs: { onfilter: _vm.onfilter, filter: _vm.filter, exclude: [] },
            on: {
              onclose: function ($event) {
                _vm.onfilter = false
              },
              onfilter: function ($event) {
                return _vm.ONFILTER()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ondelete
        ? _c("modal-delete", {
            attrs: { ondelete: _vm.ondelete, id: _vm.id },
            on: {
              onclose: function ($event) {
                _vm.ondelete = false
              },
              onreload: function ($event) {
                return _vm.ONFILTER()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ondeliver
        ? _c("modal-deliver", {
            attrs: { ondeliver: _vm.ondeliver, id: _vm.id },
            on: {
              onclose: function ($event) {
                _vm.ondeliver = false
              },
              onreload: function ($event) {
                return _vm.ONFILTER()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "vstack gap-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column flex-md-row gap-3 justify-content-between",
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "d-flex gap-3 row",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.FILTER()
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.onfilter = true
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-funnel me-2" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Filtro")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "vr opacity-20 mx-3" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-xs text-primary" }, [
                            _vm._v(_vm._s(_vm.count_filter)),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.SORT()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "me-2",
                            class:
                              _vm.filter.sortDesc == "ASC"
                                ? "bi bi-sort-alpha-up"
                                : "bi bi-sort-alpha-down-alt",
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.filter.sortDesc))]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 px-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "input-group input-group-sm input-group-inline",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.search,
                                expression: "filter.search",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", placeholder: "Buscar..." },
                            domProps: { value: _vm.filter.search },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filter,
                                  "search",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-primary",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm.loading == "filter"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Buscar")]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.CLEAR()
                            },
                          },
                        },
                        [
                          _vm.loading == "clear"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Limpiar")]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body p-0" },
                [
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headers,
                        items:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear"
                            ? []
                            : _vm.items.data,
                        "show-expand": "",
                        "single-expand": true,
                        expanded: _vm.expanded,
                        options: _vm.options,
                        "server-items-length": _vm.items.total,
                        loading:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear",
                        "footer-props": {
                          "items-per-page-options": [5, 10, 50, 100],
                        },
                      },
                      on: {
                        "update:expanded": function ($event) {
                          _vm.expanded = $event
                        },
                        "update:options": function ($event) {
                          _vm.options = $event
                        },
                        "item-expanded": _vm.loadDetails,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.id",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "text-decoration-none",
                                    attrs: {
                                      to: {
                                        name: "PackageDetail",
                                        params: { id: item.id },
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(item.type) +
                                        _vm._s(item.id) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.state_id",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.CHECK_STATE(item.state_id)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "badge badge-pill",
                                        class: _vm.CHECK_STATE(item.state_id)
                                          .labels,
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.CHECK_STATE(item.state_id).name
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "item.payment",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                item.invoice_amount &&
                                _vm.CHECK_STATEP(item.invoice_amount.state_id)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "badge badge-pill",
                                        class: _vm.CHECK_STATEP(
                                          item.invoice_amount.state_id
                                        ).labels,
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.CHECK_STATEP(
                                              item.invoice_amount.state_id
                                            ).name
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "item.deliver",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.globalViewOption("PackageDeliver") &&
                                item.invoice_amount &&
                                item.invoice_amount.state_id == 22
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "a",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "a",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-success btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.DELIVER(
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("small", [
                                                            _c("i", {
                                                              staticClass:
                                                                "bi bi-currency-dollar",
                                                            }),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v("Entregar paquete"),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-currency-dollar",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.is_fel",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                (_vm.globalViewOption("PackageFel") &&
                                  item.invoice_amount &&
                                  item.invoice_amount.state_id) ||
                                (_vm.globalViewOption("PackageFel") &&
                                  item.is_fel)
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "a",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "a",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          staticClass:
                                                            "btn btn-info btn-m",
                                                          attrs: {
                                                            to: {
                                                              name: "PackageFel",
                                                              params: {
                                                                id: item.id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("small", [
                                                            _c("i", {
                                                              staticClass:
                                                                "bi bi-receipt",
                                                            }),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v("Factura electrónica"),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-info btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass: "bi bi-receipt",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.update",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.globalViewOption("PackageUpdate") &&
                                item.state_id != 17
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "a",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "a",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary btn-m",
                                                          attrs: {
                                                            to: {
                                                              name: "PackageUpdate",
                                                              params: {
                                                                id: item.id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("small", [
                                                            _c("i", {
                                                              staticClass:
                                                                "bi bi-pencil-square",
                                                            }),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Editar")]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass: "bi bi-pencil-square",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.delete",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.globalViewOption("PackageDelete") &&
                                item.state_id != 17
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-danger btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.DELETE(
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("small", [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-trash3",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Eliminar")]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-danger btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass: "bi bi-trash3",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.invoice_amount",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                !item.invoice_amount
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-dark btn-m",
                                        attrs: { type: "button", disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-file-earmark-font",
                                          }),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-success btn-h px-3",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.PRINT_INVOICE(
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center justify-content-center",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa-solid fa-dollar mr-1",
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                Number(
                                                                  item
                                                                    .invoice_amount
                                                                    .total || 0
                                                                ).toFixed(2)
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Factura")]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "expanded-item",
                            fn: function (ref) {
                              var headers = ref.headers
                              var item = ref.item
                              return [
                                _c("td", { attrs: { colspan: "100%" } }, [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-borderless table-sm mt-2 mb-5",
                                    },
                                    [
                                      _c("thead", { staticClass: "bg-white" }, [
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              color: "rgba(0,0,0,.6)",
                                            },
                                          },
                                          [
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Descripción"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Valor Declarado"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Tracking"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        AWB"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Creado"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Actualizado"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Ruta"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Sucursal"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Inventario"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("tbody", [
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              color: "rgba(0,0,0,.6)",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    staticClass: "mx-1",
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function (ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              Array.isArray(
                                                                item.description
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "nowrap",
                                                                        },
                                                                        "div",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                                    " +
                                                                          _vm._s(
                                                                            item
                                                                              .description[0]
                                                                          ) +
                                                                          " ...\n                                                                "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "small",
                                                      _vm._l(
                                                        item.description,
                                                        function (
                                                          description,
                                                          key
                                                        ) {
                                                          return _c(
                                                            "div",
                                                            { key: key },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  description
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        $ " +
                                                    _vm._s(
                                                      Number(
                                                        item.value || 0
                                                      ).toFixed(2)
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        " +
                                                    _vm._s(item.tracking)
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                typeof item.is_expanded ===
                                                  "undefined" &&
                                                item.awb_id !== null
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spinner-border spinner-border-sm mb-0",
                                                        attrs: {
                                                          role: "status",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr-only",
                                                          },
                                                          [_vm._v("Loading...")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c("div", [
                                                      _vm._v(
                                                        "\n                                                            " +
                                                          _vm._s(
                                                            item.awb
                                                              ? item.awb.awb +
                                                                  (item.hawb
                                                                    ? " - " +
                                                                      item.hawb
                                                                        .hawb
                                                                    : "")
                                                              : ""
                                                          ) +
                                                          "\n                                                        "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        " +
                                                    _vm._s(
                                                      _vm._f("DATETIME")(
                                                        item.created_at
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        " +
                                                    _vm._s(
                                                      _vm._f("DATETIME")(
                                                        item.updated_at
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                typeof item.is_expanded ===
                                                  "undefined" &&
                                                typeof item.deliver_route !==
                                                  "undefined"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spinner-border spinner-border-sm mb-0",
                                                        attrs: {
                                                          role: "status",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr-only",
                                                          },
                                                          [_vm._v("Loading...")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c("div", [
                                                      _vm._v(
                                                        "\n                                                            " +
                                                          _vm._s(
                                                            item.deliver_route
                                                              ? item
                                                                  .deliver_route
                                                                  .route
                                                                ? item
                                                                    .deliver_route
                                                                    .id +
                                                                  " - " +
                                                                  item
                                                                    .deliver_route
                                                                    .route
                                                                    .full_name
                                                                : ""
                                                              : ""
                                                          ) +
                                                          "\n                                                        "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                typeof item.is_expanded ===
                                                  "undefined" &&
                                                item.branch_office_id !== null
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spinner-border spinner-border-sm mb-0",
                                                        attrs: {
                                                          role: "status",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr-only",
                                                          },
                                                          [_vm._v("Loading...")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c("div", [
                                                      _vm._v(
                                                        "\n                                                            " +
                                                          _vm._s(
                                                            item.branch_office
                                                              ? item
                                                                  .branch_office
                                                                  .name
                                                              : ""
                                                          ) +
                                                          "\n                                                        "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "text-start sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                  "border-bottom":
                                                    "thin solid rgba(0,0,0,.12)",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas",
                                                  class: item.in_stock
                                                    ? "fa-check"
                                                    : "fa-close",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("tfoot", [
                                        _c(
                                          "td",
                                          {
                                            staticClass: "text-center",
                                            attrs: { colspan: "100%" },
                                          },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "text-decoration-none text-center sortable",
                                                staticStyle: {
                                                  "font-size": ".75rem",
                                                },
                                                attrs: {
                                                  to: {
                                                    name: "PackageDetail",
                                                    params: { id: item.id },
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                        Más detalles...\n                                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Paquetería")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "bi bi-search" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }